/* jshint esversion: 6 */
/* jshint ignore:start */

import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import { MyContext } from "../../Context/MyProvider";
import Loading from "../../Loading";

import logoWithName from "../../Images/logowithname.png";

import CurrentLocationChip from "./CurrentLocationChip";
import DesktopUserChip from "./DesktopUserChip";

import Login from "../Login&SignUp/Login";
import Signup from "../Login&SignUp/SignUp";

import {
    isUserLoggedIn,
    logoutUser,
    requireLogin,
} from "../../utils/auth";

import { arrangeSidebarMenuItems, openSidebarExternalUrl } from "../../utils/sidebarMenu";
import { showTost } from "../../showTost";

import {
    FiBell,
    FiHeadphones,
    FiLogOut,
    FiSearch,
    FiStar,
} from "react-icons/fi";

import { HiOutlineHome } from "react-icons/hi2";

import {
    MdOutlineAccountBalanceWallet,
    MdOutlineApps,
    MdOutlineEvent,
    MdOutlineLocalOffer,
    MdOutlineShoppingBag,
    MdOutlineSportsCricket,
} from "react-icons/md";

import { BsController } from "react-icons/bs";

import {
    FaBriefcase,
    FaHeart,
    FaTicketAlt,
    FaWpforms,
} from "react-icons/fa";

const DynamicEventDetailPage = () => {
    const {
        isLoginShow,
        setIsLoginShow,
        isSignUpShow,
        setIsSignUpShow,
        setIsLogin,
        setIsShowBtn,
    } = useContext(MyContext);

    const { slug } = useParams();
    const Navigate = useNavigate();

    const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);

    useEffect(() => {
        document.body.classList.add("desktop-home-active");

        return () => {
            document.body.classList.remove("desktop-home-active");
        };
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
        setLoading(true);

        axios
            .get(
                `https://shop.nabhiverse.com/api/v1/dynamic-pages/${slug}`
            )
            .then((res) => {
                setPageData(res?.data?.data || null);
            })
            .catch((error) => {
                console.error("dynamic-pages", error);
                setPageData(null);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [slug]);

    const handleButtonClick = () => {
        if (pageData?.button_url) {
            window.open(
                pageData.button_url,
                "_blank",
                "noopener,noreferrer"
            );
        }
    };

    const eventDetailMenuItems = [
        {
            label: "Home",
            icon: HiOutlineHome,
            path: "/",
        },
        {
            label: "Events",
            icon: MdOutlineEvent,
            path: "/events",
            active: true,
        },
        {
            label: "Sports",
            icon: MdOutlineSportsCricket,
        },
        {
            label: "Games",
            icon: BsController,
        },
        {
            label: "Shopping",
            icon: MdOutlineShoppingBag,
            externalUrl: "https://shop.nabhiverse.com/",
        },
        {
            label: "Offers",
            icon: MdOutlineLocalOffer,
        },
        {
            label: "Bookings",
            icon: FaTicketAlt,
            path: "/booking",
        },
        {
            label: "Favorites",
            icon: FaHeart,
            path: "/favorite",
        },
        {
            label: "eWallet",
            icon: MdOutlineAccountBalanceWallet,
            path: "/wallet",
        },
        {
            label: "Forms",
            icon: FaWpforms,
            path: "/form-list",
        },
        {
            label: "Business",
            icon: FaBriefcase,
            path: "/business-user",
        },
        {
            label: "More",
            icon: MdOutlineApps,
        },
        {
            label: "Logout",
            icon: FiLogOut,
            action: "logout",
        },
    ];

    const eventDetailBottomMenuItems = [
        {
            label: "Home",
            icon: HiOutlineHome,
            path: "/",
        },
        {
            label: "Forms",
            icon: FaWpforms,
            path: "/form-list",
        },
        {
            label: "Business",
            icon: FaBriefcase,
            path: "/business-user",
        },
        {
            label: "More",
            icon: MdOutlineApps,
            action: () => setIsMobileDrawerOpen(true),
        },
    ];

    const handleMenuClick = async (item) => {
        if (item.externalUrl) {
            if (item.requiresLogin !== false && !requireLogin(setIsLoginShow)) {
                return;
            }

            openSidebarExternalUrl(item);

            setIsMobileDrawerOpen(false);

            return;
        }

        if (item.action === "logout") {
            const didLogout = await logoutUser({
                navigate: Navigate,
                setIsLogin,
                setIsShowBtn,
            });

            if (didLogout) {
                showTost(
                    "Logout successfully !!",
                    "success"
                );
            }

            setIsMobileDrawerOpen(false);

            return;
        }

        if (item.path) {
            Navigate(item.path);

            setIsMobileDrawerOpen(false);
        }
    };

    const shouldShowMenuItem = (item) =>
        ![
            "Bookings",
            "Favorites",
            "eWallet",
            "Logout",
        ].includes(item.label) || isUserLoggedIn();

    const cleanHtmlContent = (html = "") => {
        return html
            .replace(/\\r\\n/g, "")
            .replace(/\\n/g, "")
            .replace(/\\r/g, "");
    };

    return (
        <div className="nabhiverse_desktop_home event_detail_layout">
            {/* Desktop Sidebar */}
            <aside className="desktop_home_sidebar">
                <div className="desktop_home_logo">
                    <Link
                        to="/"
                        aria-label="Go to home"
                    >
                        <img
                            src={logoWithName}
                            alt="Nabhiverse"
                        />
                    </Link>
                </div>

                <nav className="desktop_home_nav">
                    {arrangeSidebarMenuItems(eventDetailMenuItems)
                        .filter(shouldShowMenuItem)
                        .map((item) => {
                            const Icon = item.icon;

                            return (
                                <button
                                    key={item.label}
                                    className={`desktop_home_nav_item ${item.active
                                        ? "active"
                                        : ""
                                        }`}
                                    type="button"
                                    onClick={() =>
                                        handleMenuClick(item)
                                    }
                                >
                                    <Icon />

                                    <span>
                                        {item.label}
                                    </span>
                                </button>
                            );
                        })}
                </nav>

                <div className="desktop_home_star_box">
                    <FiStar />

                    <span>nabi star</span>

                    <strong>
                        Your Stars 620
                    </strong>

                    <button type="button">
                        View Benefits
                    </button>
                </div>

                <div className="desktop_home_help_box">
                    <FiHeadphones />

                    <span>Need Help?</span>

                    <p>24x7 Support</p>

                    <button type="button">
                        Contact Us
                    </button>
                </div>
            </aside>

            {/* Mobile Overlay */}
            <div
                className={`mobile_menu_overlay ${isMobileDrawerOpen
                    ? "show"
                    : ""
                    }`}
                onClick={() =>
                    setIsMobileDrawerOpen(false)
                }
            />

            {/* Mobile Drawer */}
            <aside
                className={`mobile_menu_drawer ${isMobileDrawerOpen
                    ? "show"
                    : ""
                    }`}
            >
                <div className="mobile_drawer_head">
                    <Link
                        to="/"
                        aria-label="Go to home"
                        onClick={() =>
                            setIsMobileDrawerOpen(false)
                        }
                    >
                        <img
                            src={logoWithName}
                            alt="Nabhiverse"
                        />
                    </Link>

                    <button
                        type="button"
                        onClick={() =>
                            setIsMobileDrawerOpen(false)
                        }
                    >
                        x
                    </button>
                </div>

                <div className="mobile_drawer_body">
                    <nav className="mobile_drawer_nav">
                        {arrangeSidebarMenuItems(eventDetailMenuItems)
                            .filter(shouldShowMenuItem)
                            .map((item) => {
                                const Icon = item.icon;

                                return (
                                    <button
                                        key={item.label}
                                        className={`desktop_home_nav_item ${item.active
                                            ? "active"
                                            : ""
                                            }`}
                                        type="button"
                                        onClick={() =>
                                            handleMenuClick(
                                                item
                                            )
                                        }
                                    >
                                        <Icon />

                                        <span>
                                            {item.label}
                                        </span>
                                    </button>
                                );
                            })}
                    </nav>

                    <div className="desktop_home_star_box">
                        <FiStar />

                        <span>
                            nabi star
                        </span>

                        <strong>
                            Your Stars 620
                        </strong>

                        <button type="button">
                            View Benefits
                        </button>
                    </div>

                    <div className="desktop_home_help_box">
                        <FiHeadphones />

                        <span>
                            Need Help?
                        </span>

                        <p>
                            24x7 Support
                        </p>

                        <button type="button">
                            Contact Us
                        </button>
                    </div>
                </div>
            </aside>

            {/* Main Content */}
            <main className="desktop_home_main">
                {/* Header */}
                <header className="desktop_home_topbar event_detail_topbar">
                    <div className="mobile_header_logo">
                        <Link
                            to="/"
                            aria-label="Go to home"
                        >
                            <img
                                src={logoWithName}
                                alt="Nabhiverse"
                            />
                        </Link>
                    </div>

                    <div className="desktop_search_box">
                        <FiSearch />

                        <input
                            type="text"
                            placeholder="Search for apps, services, movies, events and more..."
                            readOnly
                        />
                    </div>

                    <CurrentLocationChip />

                    <DesktopUserChip />

                    <button
                        className="desktop_bell_btn"
                        type="button"
                        aria-label="Notifications"
                    >
                        <FiBell />

                        <span>3</span>
                    </button>
                </header>

                {/* Dynamic Page */}
                {loading ? (
                    <Loading />
                ) : !pageData ? (
                    <div className="flex min-h-[50vh] items-center justify-center px-6 text-gray-400">
                        This page couldn't be found.
                    </div>
                ) : (
                    <div className="event_details w-full">
                        <div className="event_container w-full">
                            <div
                                className="
                                    w-full
                                    px-4
                                    py-8
                                    sm:px-5
                                    md:px-6
                                    lg:px-8
                                    xl:px-10
                                "
                            >
                                {/* Banner */}
                                {pageData?.banner_image && (
                                    <div className="w-full">
                                        <img
                                            src={
                                                pageData.banner_image
                                            }
                                            alt={
                                                pageData?.title ||
                                                "Banner"
                                            }
                                            className="
                                                block
                                                w-full
                                                max-w-none
                                                rounded-2xl
                                                object-cover
                                            "
                                        />
                                    </div>
                                )}

                                {/* Content */}
                                {pageData?.content && (
                                    <div
                                        className="
                                        mt-8
                                        w-full
                                        max-w-none
                                        text-white
                                        [&_h1]:mb-4
                                        [&_h1]:text-3xl
                                        [&_h1]:font-bold
                                        [&_h1]:text-white
                                        [&_h2]:mb-4
                                        [&_h2]:text-2xl
                                        [&_h2]:font-semibold
                                        [&_h2]:text-white
                                        [&_h3]:mb-4
                                        [&_h3]:text-2xl
                                        [&_h3]:font-semibold
                                        [&_h3]:text-white
                                        [&_p]:mb-4
                                        [&_p]:text-base
                                        [&_p]:leading-7
                                        [&_p]:text-white
                                    "
                                        dangerouslySetInnerHTML={{
                                            __html: cleanHtmlContent(pageData.content),
                                        }}
                                    />
                                )}

                                {/* CTA Button */}
                                {pageData?.button_text && (
                                    <button
                                        type="button"
                                        onClick={
                                            handleButtonClick
                                        }
                                        className="
                                            mt-8
                                            min-w-[160px]
                                            rounded-xl
                                            px-8
                                            py-3
                                            text-sm
                                            font-semibold
                                            text-white
                                            shadow-lg
                                            transition-all
                                            duration-300
                                            hover:scale-[1.02]
                                            hover:opacity-90
                                            active:scale-[0.98]
                                        "
                                        style={{
                                            background:
                                                "linear-gradient(135deg, #5b12d6, #8c26ff)",
                                        }}
                                    >
                                        {
                                            pageData.button_text
                                        }
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </main>

            {/* Mobile Bottom Menu */}
            <nav className="mobile_bottom_menu">
                {eventDetailBottomMenuItems.map(
                    (item) => {
                        const Icon = item.icon;

                        return (
                            <button
                                key={item.label}
                                type="button"
                                className={
                                    item.active
                                        ? "active"
                                        : ""
                                }
                                onClick={() =>
                                    item.action
                                        ? item.action()
                                        : Navigate(
                                            item.path
                                        )
                                }
                            >
                                <Icon />

                                <span>
                                    {item.label}
                                </span>
                            </button>
                        );
                    }
                )}
            </nav>

            {/* Login Modal */}
            {isLoginShow && (
                <div
                    onClick={() =>
                        setIsLoginShow(false)
                    }
                    className="
                        auth_modal_overlay
                        fixed
                        left-0
                        top-0
                        z-[999]
                        flex
                        h-full
                        w-full
                        items-center
                        justify-center
                        bg-[#00000069]
                    "
                >
                    <div
                        onClick={(e) =>
                            e.stopPropagation()
                        }
                        className="model mx-2 md:mx-auto"
                    >
                        <Login />
                    </div>
                </div>
            )}

            {/* Signup Modal */}
            {isSignUpShow && (
                <div
                    onClick={() =>
                        setIsSignUpShow(false)
                    }
                    className="
                        auth_modal_overlay
                        fixed
                        left-0
                        top-0
                        z-[999]
                        flex
                        h-full
                        w-full
                        items-center
                        justify-center
                        bg-[#00000069]
                    "
                >
                    <div
                        onClick={(e) =>
                            e.stopPropagation()
                        }
                        className="model"
                    >
                        <Signup />
                    </div>
                </div>
            )}
        </div>
    );
};

export default DynamicEventDetailPage;
